import React from 'react'

export default function Article({ article }) {
    return (
        <a href={article.url} target="_blank" rel="noreferrer" key={article.objectID}>
            <div className="border border-zinc-900 dark:border-zinc-100 p-4 h-72 flex flex-col justify-between transform hover:scale-[1.04] transition-all">
                <h4 className="text-xl font-semibold dark:text-white">{article.title}</h4>
                <span className='text-lg text-gray-600 dark:text-gray-400 font-semibold'>Author: {article.author}</span>
            </div>
        </a>
    )
}
